import styled from "styled-components";

export const NotificationContainer = styled.div`
  width: 400px;
  position: fixed;
  left: 0;
  bottom: 0;
  padding: 16px;
  z-index: 999;
`;